import React from 'react';
import './404Page.css';

class NotFoundPage extends React.Component {
  
    render() {
        return (
                <div className="container-fluid">
                    <h1 className="text-center">404 - page not found</h1>
                    <h2 className="text-center">
                        {' '}
                        The page you are looking for might have been removed or had its name
                        changed.
                    </h2>
                    <a href="/" className="submit-btn">
                        Go back to Login page
                    </a>
                    <div className="footer-error">
                        <div className="copyright">
                            <span className="mobile-center">
                                Copyright  © 2019 <a href="https://www.boardtrac.com.au/" target="_blank" rel="noopener noreferrer">Boardtrac Pty Ltd</a>. All Rights Reserved.
                            </span>
                        </div>
                    </div>                    
                </div>
        );
    }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/404Page.js